export const BUDGET_KEY_DATES_EVENT: string[] = [
    'entry_opening',
    'entry_closing',
    'budget_vote',
    'supplementary_budget_opening',
];
